import { newObjectId } from './Utils'

export interface Language {
    id: number
    ISOCode: string
    displayName: string
}

export function createLanguage(): Language {
    return {
        id: newObjectId,
        ISOCode: '',
        displayName: ''
    }
}